import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const featured = hotMovies.slice(0, 5);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % featured.length);
  }, [featured.length]);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + featured.length) % featured.length);
  }, [featured.length]);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  if (featured.length === 0) return null;

  const movie = featured[current];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden bg-background-50">
      {featured.map((m, idx) => (
        <div
          key={m.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={m.poster}
            alt={m.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/60 to-background-50/30"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-xl">
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                  热门推荐
                </span>
                <span className="text-sm text-foreground-500">{movie.year}</span>
                <span className="text-sm text-foreground-500">{movie.duration}</span>
              </div>

              <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
                {movie.title}
              </h1>

              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4 line-clamp-2 max-w-md">
                {movie.description}
              </p>

              <div className="flex items-center gap-3 mb-6">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-primary-500 text-sm"></i>
                  <span className="text-sm font-semibold text-primary-500">{movie.rating}</span>
                </div>
                <span className="text-foreground-300">|</span>
                <span className="text-sm text-foreground-400">导演: {movie.director}</span>
                <span className="text-foreground-300">|</span>
                <span className="text-sm text-foreground-400">
                  主演: {movie.actors.slice(0, 3).join('、')}
                </span>
              </div>

              <Link
                to={`/article/${movie.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-xl text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/30 backdrop-blur-sm border border-background-200/40 text-foreground-700 hover:bg-background-50/50 transition-all cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/30 backdrop-blur-sm border border-background-200/40 text-foreground-700 hover:bg-background-50/50 transition-all cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {featured.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`rounded-full transition-all cursor-pointer ${
              idx === current
                ? 'w-6 h-2 bg-primary-500'
                : 'w-2 h-2 bg-foreground-300/50 hover:bg-foreground-400/60'
            }`}
            aria-label={`第${idx + 1}个`}
          />
        ))}
      </div>
    </section>
  );
}